import ReactDOM from 'react-dom/client';
import DialogAsyncSelezioneLotto from '../components/DialogAsyncSelezioneLotto';

export function openDialogAsyncSelezioneLotto(): Promise<{
  lotto: string;
  dataScadenza: string;
}> {
  return new Promise((resolve) => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    const root = ReactDOM.createRoot(div);

    const handleClose = (result: { lotto: string; dataScadenza: string }) => {
      root.unmount(); // Smonta il componente
      document.body.removeChild(div); // Rimuovi il nodo dal DOM
      resolve(result); // Risolvi la Promise con il risultato
    };

    root.render(<DialogAsyncSelezioneLotto onClose={handleClose} />);
  });
}
